import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '../shared/components';
import { AuthService, RolesEnum } from '../core';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    standalone: false
})
export class ConfigComponent implements OnInit {

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Configurações' },
    ]

    filteredRelatorios: any [];
    relatorios: any = [
        { titulo: 'Configurações do Sistema', routerLink: 'configuracoes-sistema', descricao: 'Relatório de diário de operações não executados por contratos.', skipRoles: [RolesEnum.EMISSOR] },
        { titulo: 'Regras de Apontamento', routerLink: 'regras-apontamentos', descricao: 'Cadastramento de regras que podem ser aplicadas a novos apontamentos nos DIOs', skipRoles: [RolesEnum.EMISSOR] },        
        { titulo: 'Beneficiárias Coligadas Novacap', routerLink: 'gerir-coligadas-novacap', descricao: 'Página para realizar cadastramento de empresas beneficiárias que atuam com o papel Novacap na operação do Sisdio-e', skipRoles: [RolesEnum.EMISSOR, RolesEnum.FUNCIONARIO, RolesEnum.FISCAL, RolesEnum.AFERIDOR, RolesEnum.CONTRATADO_ADM] },
        { titulo: 'Aprovações', routerLink: 'aprovacoes-do-marcelinho', descricao: 'Página para gerenciar as aprovações do Marcelinho', skipRoles: [RolesEnum.EMISSOR, RolesEnum.FUNCIONARIO, RolesEnum.FISCAL, RolesEnum.AFERIDOR, RolesEnum.CONTRATADO_ADM] },
        { titulo: 'Cancelamento em Massa', routerLink: 'cancelamento-em-massa', descricao: 'Página para gerenciar cancelamentos em massa de DIOs', skipRoles: [RolesEnum.FUNCIONARIO, RolesEnum.FISCAL, RolesEnum.AFERIDOR, RolesEnum.CONTRATADO_ADM] },
    ]

    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.filteredRelatorios = this.relatorios;
    }    

    deveExibirRelatorio(skipRoles: RolesEnum[]) {
        const userRoles: string[] = this.authService.user?.realm_access?.roles || [];
        return !skipRoles.some(role => userRoles.includes(role));
    }
}
